import { useCallback } from 'react';
import { CustomButton } from '../../../../../components/CustomButton';
import RModal from '../../../../../components/Rsuite/Modal';
import api from '../../../../../services/api';
import { toastSuccess } from '../../../../../toasts';

const DeletarBeneficiosPromo = ({ open, handleClose, benefit, setBenefit, setBenefits }) => {

  const endpoint = benefit?.TipoProduto === 'TAMANHO'
    ? 'promocao-beneficio-tamanho'
    : 'promocao-beneficio';

  const handleDelete = useCallback(async () => {
    await api.delete(`${endpoint}/${benefit.Id}`)
    .then(() => {
        setBenefits((prev) => prev.filter((rl) => rl.Id !== benefit.Id));
        toastSuccess('Benefício removido com sucesso.');
        setBenefit(null);
        handleClose();
    })
    .catch(error => console.log('Erro ao remover benefício ' + error));
  },[handleClose, benefit?.Id, setBenefit, setBenefits, endpoint]);

  return(
    <RModal
      open={open}
      onClose={handleClose}
      title={"Remover benefício"}
      footer={
        <>
          <CustomButton appearance="default" onClick={handleClose}>
            Cancelar
          </CustomButton>
          <CustomButton color="red" onClick={handleDelete}>Deletar</CustomButton>
        </>
      }
    >
      Tem certeza que deseja remover benefício ?
    </RModal>
  )
}

export default DeletarBeneficiosPromo;
